"use client";

import {
  Sidebar,
  SidebarContent,
  SidebarFooter,
  SidebarHeader,
} from "@/components/ui/sidebar";
import {
  ConstructionIcon,
  Database,
  FileChartColumnIncreasingIcon,
  FileClockIcon,
  FileTextIcon,
  HomeIcon,
  SettingsIcon,
  ShieldIcon,
  TruckIcon,
  CarIcon,
  UploadIcon,
  AwardIcon,
  CreditCardIcon,
  FileCheckIcon,
  WeightIcon,
} from "lucide-react";
import { NavHeader } from "@/components/app/nav-header";
import { NavContent } from "@/components/app/nav-content";
import { NavUser, NavUserSkeleton } from "@/components/app/nav-user";
import { useSession } from "next-auth/react";
import { NavKvps } from "@/components/app/nav-kvps";
import { hasRole } from "@/lib/permissions";
import { GRP_ROLES_HRIN } from "@/lib/grp";

const data = {
  navMain: [
    {
      title: "Tableau de bord",
      url: "/backoffice/dashboard",
      icon: HomeIcon,
    },
  ],

  navCat: [
    {
      title: "Attribution véhicule",
      url: "/backoffice/cat/vehicle-assignment",
      icon: FileTextIcon,
    },
    {
      title: "Brouillons",
      url: "/backoffice/cat/drafts",
      icon: FileClockIcon,
    },
  ],

  navHrin: [
    {
      title: "Chargement RCE/CNIT",
      url: "/backoffice/hrin/load-rce-cnit",
      icon: UploadIcon,
    },
    {
      title: "Agrément / Habilitation",
      url: "/backoffice/hrin/agreement",
      icon: AwardIcon,
    },
    {
      title: "Vue Véhicule",
      url: "/backoffice/hrin/car-view",
      icon: CarIcon,
    },
    {
      title: "Homologation",
      url: "/backoffice/hrin/homologation",
      icon: ShieldIcon,
    },
    {
      title: "Base constructeur",
      url: "/backoffice/hrin/base-vin",
      icon: Database,
    },
    {
      title: "Immatriculation VN",
      url: "/backoffice/hrin/registration",
      icon: FileChartColumnIncreasingIcon,
    },
    {
      title: "Livraison",
      url: "/backoffice/hrin/delivery",
      icon: TruckIcon,
    },
    {
      title: "Données Carte Grise",
      url: "/backoffice/hrin/car-certificate",
      icon: CreditCardIcon,
    },
    {
      title: "Fin d'Usage Démonstration",
      url: "/backoffice/hrin/end-of-use-demonstration",
      icon: FileChartColumnIncreasingIcon,
    },
    {
      title: "eCOC / COC",
      url: "/backoffice/hrin/ecoc-coc",
      icon: FileCheckIcon,
    },
    {
      title: "FDM (Feuille des Mines)",
      url: "/backoffice/hrin/fdm",
      icon: WeightIcon,
    },
  ],

  navSystem: [
    {
      title: "Administration",
      url: "/backoffice/system/administration",
      icon: SettingsIcon,
    },
    // TODO:
    {
      title: "WIP",
      url: "/backoffice/wip",
      icon: ConstructionIcon,
    },
  ],
};

export function AppSidebar() {
  const { data: session, status, update } = useSession({ required: true });

  const userRoles = session?.user?.grpRoles ?? [];
  const showHrin = hasRole(userRoles, GRP_ROLES_HRIN);
  return (
    <Sidebar collapsible="icon">
      <SidebarHeader className="border-b">
        <NavHeader />
      </SidebarHeader>

      <SidebarContent>
        <NavContent items={data.navMain} />
        <NavContent label="CAT" items={data.navCat} />
        {showHrin && <NavContent label="HRIN" items={data.navHrin} />}
        <NavContent label="Système" items={data.navSystem} />
      </SidebarContent>

      <SidebarFooter className="border-t">
        {status === "authenticated" && (
          <>
            <div className="fixed right-0 bottom-0 w-md p-4">
              <NavKvps
                current={session.data.kvps.current}
                available={session.data.kvps.available}
                onCurrentChange={(kvps) => {
                  update({ kvps: { current: kvps } }).then(
                    // Because of the way the session update works, it does NOT automatically trigger a re-render of server components.
                    // As a "hack" to ensure the updated session is reflected, we reload the page after updating.
                    () => window.location.reload(),
                  );
                }}
              />
            </div>
            <NavUser user={session?.user} />
          </>
        )}

        {status === "loading" && <NavUserSkeleton />}
      </SidebarFooter>
    </Sidebar>
  );
}
